// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"a7d9f058","220":"0d9b25bf","786":"d2e9db89","914":"859eeced","984":"6e8a7248"}[chunkId] + ".chunk.css";
};